import api from "../api/axios";

async function getUserData(id) {
  
  const response = await api.get(`/api/v1/users/${id}`);

  
  return response.data.data;
}

async function getCurrentUser() {
  
  const response = await api.get("/api/v1/users/current_user");

  
  return response.data.data;
}

async function getRolesData() {
  const response = await api.get("/api/v1/users/roles");

  return response.data;
}

async function createUser(data) {
  const response = await api.post("/api/v1/users", {
    user: {
      email: data.email,
      username: data.username,
      name: data.name,
      last_name: data.lastName,
      phone: data.phone,
    },
  });
  if (!response) {
    
    throw new Error(response.statusText);
  }
  
  return response.data;
}

async function activateOrDeactiveUser(endpoint) {
  const response = await api.patch(endpoint, {});
  if (!response) {
    
    throw new Error(response.statusText);
  }
  
  return response.data;
}

async function editUser(data, id) {
  
  const response = await api.put(`/api/v1/users/${id}`, {
    user: {
      email: data.email,
      password: data.password,
      username: data.username,
      name: data.name,
      last_name: data.lastName,
      phone: data.phone,
      password_confirmation: data.confirmationPassword,
      role: data.role,
      current_password: data.currentPassword,
    },
  });
  if (!response) {
    
    throw new Error(response.statusText);
  }
  return response.data;
}

async function getUsersList(page = 1) {
  
  const response = await api.get(`/api/v1/users?page=${page}`);
  if (!response) {
    
    throw new Error(response.statusText);
  }

  return response.data;
}

async function searchUsers(query, page = 1) {
  const response = await api.get(
    `/api/v1/search/users/?q=${query}&page=${page}`
  );
  
  if (!response) {
    throw new Error(response.statusText);
  }

  return response.data;
}

async function getMyPermissions() {
  const response = await api.get("/api/v1/users/my_permissions");

  return response.data;
}

export {
  getUserData,
  getRolesData,
  createUser,
  editUser,
  getCurrentUser,
  getUsersList,
  searchUsers,
  getMyPermissions,
  activateOrDeactiveUser
};
